import type { ReactNode } from "react";

import AsyncContent from "~/components/AsyncContent";
import { useAuthTokensContext } from "~/context";



export interface NonAuthenticatedContentProps {
  children: ReactNode;
}

export function NonAuthenticatedContent({
  children,
}: Readonly<NonAuthenticatedContentProps>) {
  const { loading, error } = useAuthTokensContext();

  return (
    <AsyncContent loading={loading} error={error}>
      {children}
    </AsyncContent>
  );
}
